/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpfixstep23Inputs */

const en_crosspostinghelpfixstep23 = /** @type {(inputs: Crosspostinghelpfixstep23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back in Pulsify, click Connect again; at Meta's Pages step, opt in to your Page (choose all current and future Pages if offered) and leave every permission on.`)
};

const de_crosspostinghelpfixstep23 = /** @type {(inputs: Crosspostinghelpfixstep23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Pulsify erneut auf Verbinden klicken; beim Seiten-Schritt von Meta deine Seite aktivieren (wenn möglich „alle aktuellen und zukünftigen Seiten“) und alle Berechtigungen anlassen.`)
};

/**
* | output |
* | --- |
* | "Back in Pulsify, click Connect again; at Meta's Pages step, opt in to your Page (choose all current and future Pages if offered) and leave every permission on." |
*
* @param {Crosspostinghelpfixstep23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpfixstep23 = /** @type {((inputs?: Crosspostinghelpfixstep23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpfixstep23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpfixstep23(inputs)
	return de_crosspostinghelpfixstep23(inputs)
});
export { crosspostinghelpfixstep23 as "crosspostingHelpFixStep2" }